/*
/*
 * Page Name
 */

(function ($) {

    var swiper = new Swiper(".officetour_block03_swiper", {
        spaceBetween: 1,
        slidesPerView: 6,
        freeMode: true,
        loop: true,
        watchSlidesProgress: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
    var swiper2 = new Swiper(".officetour_block03_swiper01", {
        spaceBetween: 10,
        thumbs: {
            swiper: swiper,
        },
    });

    var swiper = new Swiper(".officetour_block07_swiper", {
        spaceBetween: 0,
        slidesPerView: 1,
        breakpoints: {
            320: {
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                },
            },
            640: {
                slidesPerView: 3,
                spaceBetween: 20
            }
        }
    });

})(jQuery);